/*
 * @Author: zhaofy
 * @Date: 2018-01-25 22:55:56
 * @Last Modified by: zhaofy
 * @Last Modified time: 2018-02-01 22:57:16
 */
<template>
  <!-- 图片预览和放到 -->
  <div class="gallery">
    <!-- 大图 -->
    <div class="bigImg"
      @mouseover="sMouseover"
      @mousemove="sMousemove"
      @mouseout="sMouseout"
      ref="bigImg">
      <img :src="gallery.bigImg">
      <div class="selector"></div>
      <div class="preview-btn" v-if="gallery.video !== undefined">
        <span class="video-icon" @click="playVideo"></span>
      </div>
    </div>
    <div class="video" v-show="goodsVideo">
      <a href="#none" class="close-video" @click="closeVideo"></a>
<!--      <a href="#none" class="play-video" @click="playVideo"></a>-->
      <video :src="gallery.video" controls ref="video"></video>
    </div>


    <!-- 小图 -->
    <div class="smallImg">
      <div v-for="(item, index) of gallery.list" @mouseenter="mGallery(index)">
        <img :src="item.small" :class="{'active': gallery.currIndex === index}">
      </div>
    </div>
    <!-- 放大 -->
    <div class="big-view" ref="bigView">
      <img :src="gallery.bigImg">
    </div>
  </div>
</template>
<script>
  export default {
    name: 'gallery',
    props: {
      gallery: [Object] // 图片集合
    },
    data () {
      return {
        rate: 558/325, // 图片缩放比例，放大后图与原图比例
        goodsVideo: false
      }
    },
    mounted () {
      // 所需对象集合
      this.bigElm = this.$refs.bigImg.children[0] // 原图对象
      this.selectorElm = this.$refs.bigImg.children[1] // 鼠标进入时遮罩对象
      this.viewElm = this.$refs.bigView // 放大的图片对象
      // 原图宽高
      this.width = this.bigElm.getBoundingClientRect().width
      this.height = this.bigElm.getBoundingClientRect().height
      // selector遮罩一半的高度
      this.selWidth = Math.floor(this.selectorElm.getBoundingClientRect().width / 2)
      // 遮罩隐藏
      this.selectorElm.style.display = 'none'
    },
    methods: {
      // 小图切换大图
      mGallery (index) {
        this.gallery.currIndex = index
        this.gallery.bigImg = this.gallery.list[index].big
      },
      translate3d (x = 0, y = 0) {
        return `translate3d(${x}px, ${y}px, 0)`
      },
      // 鼠标进入
      sMouseover (e) {
        // 重新获取图片相对于视窗的位置
        this.top = this.bigElm.getBoundingClientRect().top
        this.left = this.bigElm.getBoundingClientRect().left
        this.selectorElm.style.display = 'block'
        this.viewElm.style.display = 'block'
        // 设置位置
        this.offsetWidth = e.clientX - this.left
        this.offsetHeight = e.clientY - this.top
        this.countPosition()
      },
      // 鼠标移动
      sMousemove (e) {
        // console.log(this.left + '/' + this.top +'--' + e.clientX +'/'+e.clientY)
        this.offsetWidth = e.clientX - this.left
        this.offsetHeight = e.clientY - this.top
        this.countPosition()
      },
      // 鼠标移出
      sMouseout (e) {
        this.selectorElm.style.display = 'none'
        this.viewElm.style.display = 'none'
      },
      // 计算显示大图位置
      countPosition () {
        // x方向
        if (this.offsetWidth < this.selWidth) { // 左边固定
          this.sel3dX = 0
          this.view3dX = 0
        } else if (this.offsetWidth >= this.width - this.selWidth) { // 右边固定
          this.sel3dX = this.width - this.selWidth * 2
          this.view3dX = -(this.width - this.selWidth * 2) * this.rate
        } else { // 中间可移动
          this.sel3dX = this.offsetWidth - this.selWidth
          this.view3dX = -(this.offsetWidth - this.selWidth) * this.rate
        }
        // y方向
        if (this.offsetHeight < this.selWidth) { // 上边固定
          this.sel3dY = 0
          this.view3dY = 0
        } else if (this.offsetHeight >= this.height - this.selWidth) { // 下边固定
          this.sel3dY = this.height - this.selWidth * 2
          this.view3dY = -this.sel3dY * this.rate
        } else { // 中间可移动
          this.sel3dY = this.offsetHeight - this.selWidth
          this.view3dY = -this.sel3dY * this.rate
        }
        // 遮罩部分
        this.selectorElm.style.webkitTransform = this.translate3d(this.sel3dX, this.sel3dY)
        // 大图部分
        this.$refs.bigView.children[0].style.webkitTransform = this.translate3d(this.view3dX, this.view3dY)
      },
      // 播放视频
      playVideo() {
        const _this = this;
        this.goodsVideo = true;
        this.$refs.video.play();
        this.$refs.video.onended = function () {
         // 播放完成
          _this.goodsVideo = false;
        }
      },
      closeVideo() {
        this.goodsVideo = false;
        this.$refs.video.load();
      }
    }
  }
</script>
<style scoped lang="less">
  .gallery{
    width: 360px;
    float: left;
    display: inline;
    .bigImg{
      position: relative;
      float: left;
      width: 325px;
      height: 325px;
      margin: 0 18px;
      overflow: hidden;
      text-align: center;
      img{
        width: 100%;
        height: 100%;
      }
      .selector{
        position: absolute;
        left: 0;
        top: 0;
        width: 189px;
        height: 189px;
        cursor: crosshair;
        filter: alpha(opacity=15);
        -moz-opacity: 0.15;
        opacity: 0.15;
        background-color: #000;
        border: 1px solid #fff
      }
    }

    .video {
      position: absolute;
      top: 0;
      left: 0;
      width: 325px;
      height: 325px;
      margin: 0 18px;
      background: #000;
      display: inline-block;
      z-index: 999!important;
      video {
        width: 100%;
        height: 100%;
      }
    }
/*
    .play-video {
      cursor: pointer;
      position: absolute;
      right: 156px;
      top: 156px;
      width: 12px;
      height: 12px;
      background-image: url('../../assets/images/vedio-play.png');
      background-position: -45px -40px;
      z-index: 1000!important;
    }
    */
    .close-video {
      cursor: pointer;
      position: absolute;
      right: 15px;
      top: 15px;
      width: 12px;
      height: 12px;
      background-image: url('../../assets/images/vedio-close.png');
      background-size: 12px 12px;
      z-index: 1000!important;
    }

    .smallImg{
      position: relative;
      height: 52px;
      margin: 10px 18px 0px;
      width: 360px;
      overflow: hidden;
      float: left;
      div{
        height: 52px;
        width: 52px;
        overflow: hidden;
        float: left;
        text-align: center;
        margin-right: 8px;
        img{
          width: 48px;
          height: 48px;
          cursor: pointer;
          border: 2px solid #fff;
        }
      }
      .active{
        width: 48px;
        height: 48px;
        border: 2px solid #e4393c;
      }
    }
    .big-view{
      display: none;
      width: 325px;
      height: 325px;
      top: 0px;
      left: 350px;
      position: absolute;
      border: 1px solid #ddd;
      overflow: hidden;
      z-index: 999;
      img{
        position: absolute;
        width: 558px;
        height: 558px;
      }
    }

    .preview-btn {
      position: absolute;
      z-index: 5;
      bottom: 88px;
      left: 0;
      width: 100%;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      justify-content: center;
      text-align: center;
    }

    .preview-btn .video-icon {
      cursor: pointer;
      display: inline-block;
      width: 50px;
      height: 50px;
      background: url('../../assets/images/vedio-play.png');
      background-size: 50px 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// module-gallery.vue?4548e33f